import React from 'react';
import { Cog, Mail, User } from 'lucide-react';
import { APPLIED_REASONS, EVENT_SOURCES, statusMeta } from '../../constants/shipments';
import { formatDateTime } from '../../utils/shipmentsFormat';
import { StatusIcon } from './StatusBadge';

const SOURCE_ICONS = { email: Mail, manual: User, system: Cog };

// History of the shipment, oldest first. Events that did not change the status (not applied) are dashed
// and say why in words (pending review, manual lock, terminal state, older than the current state, rejected).
const Timeline = ({ events }) => {
  if (!events || events.length === 0) return <p className="shp-muted" style={{ margin: 0 }}>Zatím žádné události.</p>;
  return (
    <ol className="shp-timeline" aria-label="Historie zásilky od nejstarší události">
      {events.map((ev) => {
        const meta = statusMeta(ev.type);
        const SourceIcon = SOURCE_ICONS[ev.source] || Cog;
        const emailId = Number(ev.emailId);
        return (
          <li key={ev.id} className={ev.applied ? '' : 'is-skipped'}>
            <span className="shp-timeline__icon" style={ev.applied ? { background: meta.bg, color: meta.color } : undefined}>
              <StatusIcon status={ev.type} size={13} />
            </span>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 10px', alignItems: 'center' }}>
              <strong style={{ fontSize: 14 }}>{meta.label}</strong>
              <span className="shp-small shp-muted" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                <SourceIcon size={13} aria-hidden="true" /> {EVENT_SOURCES[ev.source] || 'Systém'}
              </span>
              <time className="shp-small shp-muted" dateTime={ev.occurredAt}>{formatDateTime(ev.occurredAt)}</time>
            </div>
            {!ev.applied && (
              <p className="shp-small" style={{ margin: '4px 0 0', color: '#555' }}>
                <span className="shp-tag shp-tag--warn">Neprojevilo se ve stavu</span>{' '}
                {APPLIED_REASONS[ev.appliedReason] || 'Událost nezměnila stav zásilky.'}
              </p>
            )}
            {ev.note && <p className="shp-wrap" dir="auto" style={{ margin: '4px 0 0', fontSize: 14 }}>{ev.note}</p>}
            {Number.isInteger(emailId) && emailId > 0 && ev.source === 'email' && (
              <a href={`#email-${emailId}`} className="shp-small" style={{ display: 'inline-block', marginTop: 4 }}>Zdrojový e-mail</a>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default Timeline;
